export default "__VITE_ASSET__D4h06K9O__"